import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Camera, BookOpen } from 'lucide-react';
export const CreatorsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  const creators = [{
    name: 'Kanwar Singh Dhillon',
    role: 'Visual Artist',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qyiWpXgsTbQ8qffx5zoMhp/KanwarSingh.jpg',
    icon: <Camera className="w-5 h-5" data-id="element-975" />,
    description: 'Renowned for his Art of Punjab collection, bringing historical moments to life through vibrant, detailed artwork.',
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6TA9bnDgaF4queat9qTtnf/Screenshot_2025-10-08_at_10.47.29_PM.png'
  }, {
    name: 'Inkquisitive',
    role: 'Visual Artist',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPPtrXJSvzXxH8SA4Qh5Q6/Inkquisitive_Aman_looking_right.webp',
    icon: <Camera className="w-5 h-5" data-id="element-976" />,
    description: 'Global contemporary Sikh artist specializing in immersive digital experiences and cutting-edge projection mapping.',
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aNk557nof1kNhT4tzQY7ze/Screenshot_2025-10-08_at_10.48.47_PM.png'
  }, {
    name: 'Sarbpreet Singh',
    role: 'Story Consultant',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fjZT6BXdSgT5X1VfqK593T/sarbpreet_singh.jpg',
    icon: <BookOpen className="w-5 h-5" data-id="element-977" />,
    description: 'Host of The Story of the Sikhs podcast, bringing historical narratives to life through authentic storytelling.',
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fTHgkCdqA3ZjhsQgSngNAE/story_of_sikhs_.jpg'
  }];
  return <motion.section id="creators" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-978">
      <div className="container mx-auto px-4" data-id="element-979">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-980">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-981">
            Visionary Minds
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-982">
            THE
            <br data-id="element-983" />
            <span className="text-amber-400" data-id="element-984">CREATORS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-985"></div>
        </motion.div>
        {/* Award-winning teams */}
        <div className="mb-24 max-w-5xl mx-auto" data-id="element-986">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-987">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="border border-white/10 p-8" data-id="element-988">
              <div className="mb-6" data-id="element-989">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bkLr1CMuqSBd6pu7RzMCxA/Screenshot_2025-10-08_at_9.49.05_PM.png" alt="Oscar Award" className="w-20 h-auto rounded-lg" data-id="element-990" />
              </div>
              <h4 className="text-xl font-serif text-white mb-3" data-id="element-991">
                Oscar-winning Animators
              </h4>
              <p className="text-white/60 font-light" data-id="element-992">
                The team behind Lord of the Rings brings their mastery of visual
                storytelling to recreate the Sikh Kingdom's grandeur.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="border border-white/10 p-8" data-id="element-993">
              <div className="mb-6" data-id="element-994">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iGtrqhEqCZgpged46uK4JA/Screenshot_2025-10-08_at_9.50.49_PM.png" alt="Emmy Award" className="w-20 h-auto rounded-lg" data-id="element-995" />
              </div>
              <h4 className="text-xl font-serif text-white mb-3" data-id="element-996">
                Emmy-winning Artists
              </h4>
              <p className="text-white/60 font-light" data-id="element-997">
                The creative minds behind Hasbro's global installations lend
                their expertise to craft immersive environments.
              </p>
            </motion.div>
          </div>
        </div>
        {/* Sikh Visionaries */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-24 max-w-6xl mx-auto" data-id="element-998">
          {creators.map((creator, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group" data-id="element-999">
              <div className="flex items-start gap-6" data-id="element-1000">
                <div className="relative flex-shrink-0" data-id="element-1001">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-amber-400/30" data-id="element-1002">
                    <img src={creator.image} alt={creator.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-1003" />
                  </div>
                  <div className="absolute -bottom-2 -right-2 w-12 h-12 overflow-hidden border border-amber-400/50 rounded-lg bg-black" data-id="element-1004">
                    <img src={creator.thumbnail} alt={`${creator.name}'s work`} className="w-full h-full object-cover" data-id="element-1005" />
                  </div>
                </div>
                <div className="flex-1 pt-2" data-id="element-1006">
                  <div className="flex items-center mb-2" data-id="element-1007">
                    <div className="text-amber-400 mr-2" data-id="element-1008">{creator.icon}</div>
                    <p className="text-amber-400/70 text-xs tracking-wider uppercase" data-id="element-1009">
                      {creator.role}
                    </p>
                  </div>
                  <h3 className="font-serif text-xl text-white mb-2" data-id="element-1010">
                    {creator.name}
                  </h3>
                  <p className="text-white/60 text-sm font-light leading-relaxed" data-id="element-1011">
                    {creator.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
        {/* Technology Partners */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-1012">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1013">
            <div className="border border-white/10 p-6 text-center" data-id="element-1014">
              <h3 className="text-amber-400 tracking-wider uppercase text-sm mb-4" data-id="element-1015">
                Gen AI Studio
              </h3>
              <div className="flex justify-center mb-4" data-id="element-1016">
                <div className="w-20 h-20 rounded-lg overflow-hidden border border-amber-400/30" data-id="element-1017">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2dTJiTKCByJiT1M31ApAvv/image.png" alt="ATHINK AI Studio" className="w-full h-full object-cover" data-id="element-1018" />
                </div>
              </div>
              <p className="text-white/60 text-xs font-light" data-id="element-1019">
                Cutting-edge generative AI technology
              </p>
            </div>
            <div className="border border-white/10 p-6 text-center" data-id="element-1020">
              <h3 className="text-amber-400 tracking-wider uppercase text-sm mb-4" data-id="element-1021">
                Producer
              </h3>
              <div className="flex justify-center mb-4" data-id="element-1022">
                <div className="w-20 h-20 rounded-lg overflow-hidden border border-amber-400/30" data-id="element-1023">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfUmCGwV8VKNhoTqyFkwKd/secret_location.jpg" alt="Secret Location" className="w-full h-full object-cover" data-id="element-1024" />
                </div>
              </div>
              <p className="text-white/60 text-xs font-light" data-id="element-1025">
                Award-winning production company
              </p>
            </div>
            <div className="border border-white/10 p-6 text-center" data-id="element-1026">
              <h3 className="text-amber-400 tracking-wider uppercase text-sm mb-4" data-id="element-1027">
                Beverage Curator
              </h3>
              <div className="flex justify-center mb-4" data-id="element-1028">
                <div className="w-24 h-20 overflow-hidden border border-amber-400/30 bg-white flex items-center justify-center rounded-lg" data-id="element-1029">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9rVcjFgryVT5M4PXCLffva/image.png" alt="Mystical Mocktails" className="w-full h-full object-contain p-2" data-id="element-1030" />
                </div>
              </div>
              <p className="text-white/60 text-xs font-light" data-id="element-1031">
                Mystical Mocktails
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>;
};